import { useLocale } from "@/hooks/useLocale";
import { eachDayOfInterval, endOfWeek, format, startOfWeek } from "date-fns";
import { useMemo } from "react";

export const useWeekdays = () => {
  const locale = useLocale();

  const weekdays = useMemo(() => {
    const now = new Date();
    const arr = eachDayOfInterval({
      start: startOfWeek(now, { weekStartsOn: 1 }),
      end: endOfWeek(now, { weekStartsOn: 1 }),
    });
    return arr.map((day) => ({
      label: format(day, "EEEEEE", { locale }),
      value: format(day, "EEEEEE"),
    }));
  }, [locale]);

  return weekdays;
};
